import { useEffect, useRef } from 'react';
import api from '../api/client';
import { useAuth } from './useAuth';

export function useHeartbeat(intervalMs = 30000) {
  const { user } = useAuth();
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!user) return;

    const sendHeartbeat = () => {
      api.post('/api/v1/heartbeat').catch(() => {});
    };

    sendHeartbeat();
    intervalRef.current = setInterval(sendHeartbeat, intervalMs);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [user, intervalMs]);
}
